// extracted by mini-css-extract-plugin
export var createdDate = "_m0-1";
export var divider = "_m0-2";
export var headerDivider = "_m0-3";
export var messagesCard = "_m0-0";
export var messagesContainer = "_m0-7";
export var messagesContainerWrapper = "_m0-4";
export var pointerCapturingButtonBoxes = "_m0-a";
export var showLeftPanelButton = "_m0-9";
export var showMoreButton = "_m0-c";
export var showMoreButtonContainer = "_m0-b";
export var summaryTitle = "_m0-6";
export var systemMessageCardWrapper = "_m0-d";
export var topButtons = "_m0-8";
export var withPadding = "_m0-5";